



































































































import { Component, Watch } from 'nuxt-property-decorator'
import { ComponentVue } from '@/base'
import {
  alertStore,
  modalErrorStore,
  modalJobListStore
} from '@/utils/store-accessor'
import { AlertMessage, Download, ErrorMessage, Job } from '@/api'
import { JobIdMaxDigits, JobStatus } from '@/types'
import { countBy } from 'lodash'

interface Counter {
  waiting: number
  creating: number
  complete: number
  cancel: number
  error: number
}

@Component({
  components: {}
})
export default class ModalJobList extends ComponentVue {
  intervalId: number = 0

  get cssCustomProperty(): any {
    const contentHeight: number = 48

    return {
      '--max-height': contentHeight * 4 + 4 + 'px'
    }
  }

  get isOpen(): boolean {
    return this.jobs.length > 0
  }

  get jobs(): Job[] {
    return modalJobListStore.jobs
  }

  get lastJob(): Job | null {
    if (this.jobs.length === 0) return null
    return this.jobs[0]
  }

  get counter(): Counter {
    if (this.jobs.length === 0) {
      return {
        waiting: 0,
        creating: 0,
        complete: 0,
        cancel: 0,
        error: 0
      }
    }

    const count = countBy(this.jobs, job => job.status.code)
    return {
      waiting: count[JobStatus.Waiting] ?? 0,
      creating: count[JobStatus.Creating] ?? 0,
      complete: count[JobStatus.Complete] ?? 0,
      cancel: count[JobStatus.Cancel] ?? 0,
      error: count[JobStatus.Error] ?? 0
    }
  }

  get title() {
    if (this.lastJob === null) return ''

    if (this.lastJob.status.code === JobStatus.Creating) {
      return '作成中です。'
    }

    if (this.lastJob.status.code === JobStatus.Waiting) {
      return '待機中です。'
    }

    if (
      this.lastJob.status.code === JobStatus.Error ||
      this.lastJob.status.code === JobStatus.Cancel
    ) {
      return this.lastJob.message.length > 30
        ? this.lastJob.message.substr(0, 30) + '…'
        : this.lastJob.message
    }

    if (this.lastJob.status.code === JobStatus.Complete) {
      return '作成が完了しました。'
    }

    return '作成が完了しました。'
  }

  get jobStatusIsWaiting(): JobStatus {
    return JobStatus.Waiting
  }

  get jobStatusIsCreating(): JobStatus {
    return JobStatus.Creating
  }

  get jobStatusIsComplete(): JobStatus {
    return JobStatus.Complete
  }

  get jobStatusIsCancel(): JobStatus {
    return JobStatus.Cancel
  }

  get jobStatusIsError(): JobStatus {
    return JobStatus.Error
  }

  @Watch('counter')
  onChangeCounter() {
    if (this.counter.waiting > 0) {
      this.startWatch()
      return
    }

    if (this.counter.creating > 0) {
      this.startWatch()
      return
    }

    this.stopWatch()
  }

  beforeDestroy() {
    clearInterval(this.intervalId)
  }

  startWatch() {
    if (this.intervalId > 0) {
      return
    }

    this.intervalId = window.setInterval(() => {
      if (this.jobs.length > 0) {
        modalJobListStore.fetch()
      }
    }, 500)
  }

  stopWatch() {
    if (this.intervalId > 0) {
      clearInterval(this.intervalId)
      this.intervalId = 0
    }
  }

  jobIdFormat(id: number) {
    return id.toString().padStart(JobIdMaxDigits, '0')
  }

  close() {
    this.stopWatch()
    modalJobListStore.clear()
  }

  onClickCsv(job: Job) {
    location.href = job.csvUrl
  }

  onClickOpen(job: Job) {
    try {
      this.$webSocket.sendOpenExcelMessage({
        formatType: job.formatType,
        csvUrl: job.csvUrl,
        templateUrl: job.templateUrl
      })
    } catch (error) {
      if (error instanceof AlertMessage) {
        alertStore.setItems(error.alerts)
        this.$modalAlert.open({
          modalType: 'ERROR'
        })
      } else if (error instanceof ErrorMessage) {
        modalErrorStore.init(error)
        this.$modalError.open()
      } else {
        console.error(error)
      }
    }
  }

  onClickDownload(download: Download) {
    const a = document.createElement('a')
    document.body.appendChild(a)
    a.download = download.fileName
    a.href = download.url
    a.click()
    a.remove()
  }
}
